import * as marietta from '../..';
import { SVGSprite } from '../flash/display';

export default class GridLayer {
    x: number;

    y: number;

    public spt: SVGSprite;

    private lines: SVGGElement[];

    private _viewObj: Element;

    private initialized: boolean;

    /**
     * Constructor
     */
    constructor(_layerGroup: SVGSprite) {
      const viewObj: SVGGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.id = 'grid';
      this.lines = [];

      viewObj.classList.add('svgSprite');
      this.spt = new SVGSprite(viewObj);

      _layerGroup.addChild(this.spt);
      this._viewObj = viewObj;

      if (!marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
        this.createLines();
      }
    }

    public createLines(): void {
      this.initialized = true;

      const viewObj: Element = this._viewObj;

      const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('width', marietta.webcad.WebCADGlobal.LAYER_SIZE_W.toString());
      rect.setAttribute('height', marietta.webcad.WebCADGlobal.LAYER_SIZE_H.toString());
      rect.setAttribute('fill', 'white');
      rect.setAttribute('fill-opacity', '0.7');
      viewObj.appendChild(rect);

      // グリッド線の描画
      const numW = Math.ceil(marietta.webcad.config.WebCADConfig.prototype.LAYER_SIZE_W / marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID);
      const numH = Math.ceil(marietta.webcad.config.WebCADConfig.prototype.LAYER_SIZE_H / marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID);

      // html内インラインSVGから呼び出す方法に変更
      const $path1 = document.querySelector('#lib_gridLineh svg > g');
      const $path2 = document.querySelector('#lib_gridLinev svg > g');
      let $path;

      // gridColorとbackgroundColorは、ブラウザーのLocalStorage値に基づいて変化します
      if (localStorage.getItem('gridColor') !== null) {
        this.changeColor(localStorage.getItem('gridColor'), '');
      }
      if (localStorage.getItem('backgroundColor') !== null) {
        this.changeColor('', localStorage.getItem('backgroundColor'));
      }

      for (let i = 1; i < numH; i += 1) {
        // html内インラインSVGから呼び出す方法に変更
        const transformMatrix = `matrix(1,0,0,1,${0},${i * marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID})`;
        $path = $path1.cloneNode(true);
        $path.setAttribute('transform', transformMatrix);
        viewObj.append($path);

        this.lines.push($path);
      }
      for (let i = 0; i < numW; i += 1) {
        // html内インラインSVGから呼び出す方法に変更
        const transformMatrix = `matrix(1,0,0,1,${i * marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID},${0})`;
        $path = $path2.cloneNode(true);
        $path.setAttribute('transform', transformMatrix);
        viewObj.append($path);

        this.lines.push($path);
      }

      // ブラウザのLocalStorage値に基づいてMergeGridUnitを表示/非表示
      if (localStorage.getItem('showMergeUnitGrid') === '1' || localStorage.getItem('showMergeUnitGrid') === null) {
        this.showMergeGridUnit();
      } else {
        this.hideMergeGridUnit();
      }
      // 平方単位を結合するために使用される関数
      this.createSquareMerge(marietta.webcad.WebCADGlobal.mergeSquareUnit);

      if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) {
        viewObj.addEventListener('mousedown', this.onMouseDownMe);
      } else {
        viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      }
    }

    /**
     * 平方単位を結合するために使用される関数
     * @param mergeunit type= number; 結合する正方形の数
     * @return void
    */
    public createSquareMerge(mergeunit:number): void {
      const viewObj: Element = this._viewObj;
      const mergenumW = Math.ceil(marietta.webcad.config.WebCADConfig.prototype.LAYER_SIZE_W / (marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID * mergeunit));
      const mergenumH = Math.ceil(marietta.webcad.config.WebCADConfig.prototype.LAYER_SIZE_H / (marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID * mergeunit));
      const $mergePath1 = document.querySelector('#lib_mergeGridLineh svg > g');
      const $mergePath2 = document.querySelector('#lib_mergeGridLinev svg > g');
      let $mergePath: any;
      for (let i = 1; i < mergenumH; i += 1) {
        const transformMatrix = `matrix(1,0,0,1,${0},${i * (marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID * mergeunit)})`;
        $mergePath = $mergePath1.cloneNode(true);
        $mergePath.setAttribute('transform', transformMatrix);
        viewObj.append($mergePath);
        this.lines.push($mergePath);
      }
      for (let i = 0; i < mergenumW; i += 1) {
        const transformMatrix = `matrix(1,0,0,1,${i * (marietta.webcad.config.WebCADConfig.prototype.PIX_PER_GRID * mergeunit)},${0})`;
        $mergePath = $mergePath2.cloneNode(true);
        $mergePath.setAttribute('transform', transformMatrix);
        viewObj.append($mergePath);
        this.lines.push($mergePath);
      }
    }

    /**
     * グリッドレイヤーがクリックされた
     */
    onMouseDownMe = () => {
      // 複数選択モード中は、アイテム以外（グリッド）をタップしただけでは選択を解除しない。
      // 解除は「複数選択」ボタンの再タップ（明示的なOFF操作）でのみ行う。
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isMultipleSelect) return;
      // 選択中のアイテムをなしにする
      if (!marietta.webcad.WebCADGlobal.itemManager.isDrawMode) {
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
        marietta.webcad.WebCADGlobal.itemManager.currentItemGroup = null;
        marietta.webcad.WebCADGlobal.itemManager.currentWall = null;
        marietta.webcad.WebCADGlobal.itemManager.currentWallGroup = null;
      }

      // アイテムコントロールパネルを非表示にする
      marietta.webcad.WebCADGlobal.itemControlPanel.hide();
    }

    /**
     * グリッド線幅更新
     */
    lineStrokeUpdate= () => {
      const strokeWidth = 0.5 / marietta.webcad.WebCADGlobal.scaleSize;
      document.querySelector('#Layer0_0_FILL_gridLinev path').setAttribute('stroke-width', strokeWidth.toString());
      document.querySelector('#Layer0_0_FILL_gridLineh path').setAttribute('stroke-width', strokeWidth.toString());

      const strokeWidth2 = 1 / marietta.webcad.WebCADGlobal.scaleSize;
      document.querySelector('#Layer0_0_FILL_mergeGridLinev path').setAttribute('stroke-width', strokeWidth2.toString());
      document.querySelector('#Layer0_0_FILL_mergeGridLineh path').setAttribute('stroke-width', strokeWidth2.toString());
    }

    public refreshLines(): void {
      if (marietta.webcad.WebCADGlobal.userAgentManager.isIE) {
        if (!this.initialized) {
          this.createLines();
        }
      }
    }

    /**
     * グリッドの表示
     * @return void
    * */
    showGrid = () => {
      const scope = this;
      this.lines.forEach((value:SVGGElement, index:number) => {
        scope.lines[index].style.display = 'block';
      });
    }

    /**
     * グリッドの非表示
     * @return void
    * */
    hideGrid = () => {
      const scope = this;
      this.lines.forEach((value:SVGGElement, index:number) => {
        scope.lines[index].style.display = 'none';
      });
    }

    /**
     * gridColorとbackgroundColorの変更
     * @return void
     * @param gridColor => gridColor値
     * @param backgroundColor => backgroundColor値
     *
    * */
    changeColor = (gridColor: any, backgroundColor: any) => {
      if (gridColor) {
        document.querySelector('#Layer0_0_FILL_gridLinev path').setAttribute('stroke', gridColor.toString());
        document.querySelector('#Layer0_0_FILL_gridLineh path').setAttribute('stroke', gridColor.toString());
        document.querySelector('#Layer0_0_FILL_mergeGridLinev path').setAttribute('stroke', gridColor.toString());
        document.querySelector('#Layer0_0_FILL_mergeGridLineh path').setAttribute('stroke', gridColor.toString());
      }
      if (backgroundColor) {
        document.querySelector('#layerGroup').querySelector('#grid').querySelector('rect').setAttribute('fill', backgroundColor);
      }
    }

    /**
     * MergeGridUnitを表示
     * @return void
    */
    showMergeGridUnit = () => {
      document.querySelector('#Layer0_0_FILL_mergeGridLinev').setAttribute('display', 'block');
      document.querySelector('#Layer0_0_FILL_mergeGridLineh').setAttribute('display', 'block');
    }

    /**
     * MergeGridUnitを非表示にします
     * @return void
    */
    hideMergeGridUnit = () => {
      document.querySelector('#Layer0_0_FILL_mergeGridLinev').setAttribute('display', 'none');
      document.querySelector('#Layer0_0_FILL_mergeGridLineh').setAttribute('display', 'none');
    }
}
